// TODO: Delete file after one data migration. Replaced by ReadLoyaltyBenefits

import { fromJS } from 'immutable';
import { generateUrls, Selectors, Utils } from '@americanexpress/axp-benefits-utils';
import { getProduct } from '@americanexpress/product-ducks';

export const FETCH_BENEFITS_REQUEST = 'modules/axp-benefits-view-all/FETCH_BENEFITS_REQUEST';
export const FETCH_BENEFITS_SUCCESS = 'modules/axp-benefits-view-all/FETCH_BENEFITS_SUCCESS';
export const FETCH_BENEFITS_ERROR = 'modules/axp-benefits-view-all/FETCH_BENEFITS_ERROR';

const initialState = fromJS({});

// eslint-disable-next-line default-param-last -- needed
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_BENEFITS_REQUEST:
      return state
        .set('data', undefined)
        .set('error', false)
        .set('isFetching', true);
    case FETCH_BENEFITS_SUCCESS:
      if (action.data && action.data.data && action.data.data.benefitsContent) {
        return state
          .set('error', false)
          .set('data', action.data.data.benefitsContent)
          .set('isFetching', false);
      }
      return state
        .set('data', undefined)
        .set('error', true)
        .set('isFetching', false);
    case FETCH_BENEFITS_ERROR:
      return state
        .set('data', undefined)
        .set('error', true)
        .set('isFetching', false);
    default:
      return state;
  }
}

export const fetchBenefits = (cardname, loggedin, windowOrigin, fromParameters) => (
  dispatch, getState
) => {
  const state = getState();
  const product = getProduct(state);
  const accountToken = product && product.account_token;
  const locale = Selectors.getLocale(state);
  const origin = windowOrigin || 'https://global.americanexpress.com';
  const environment = Utils.getSubdomain(origin);
  const environmentLocaleFilename = fromJS(getState()).getIn(['config', 'localeFilename']);
  const { GRAAS_ENDPOINT } = generateUrls(environmentLocaleFilename, windowOrigin);
  const url = GRAAS_ENDPOINT; // mock-benefits-dashboard - do not alter this line
  // const url = 'http://localhost:2020/graphql'; // mock-benefits-dashboard - do not alter this line

  const promise = fetch(url, {
    timeout: 20000,
    method: 'POST',
    ...!fromParameters ? { credentials: 'include' } : {},
    headers: {
      'Content-Type': 'application/json',
      ...accountToken ? { account_token: accountToken } : {},
      cardname,
      // mock: true, // mock-benefits-dashboard - do not alter this line
    },
    body: JSON.stringify({
      variables: {
        environment,
        locale,
        cardname,
        loggedin: fromParameters ? false : loggedin,
      },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      dispatch({
        data,
        lastFetched: Date.now(),
        type: FETCH_BENEFITS_SUCCESS,
      });
      return data;
    })
    .catch((error) => {
      dispatch({
        error,
        type: FETCH_BENEFITS_ERROR,
      });
      return Promise.reject(error);
    });

  dispatch({
    type: FETCH_BENEFITS_REQUEST,
    promise,
  });

  return promise;
};
